import { render, staticRenderFns } from "./master.vue?vue&type=template&id=0df50a4a&"
import script from "./master.vue?vue&type=script&lang=js&"
export * from "./master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports